import React from 'react';

import { ThemeProvider } from '@livingpackets/design-system-react';
import { ThemeProvider as DSThemeProvider } from '@lp/ds-next';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { Routes, Route } from 'react-router-dom';

import AppState from './AppState';
import GlobalStyle from './GlobalStyle';
import MainRouter from './MainRouter';
import useAppState from '../hooks/useAppState';
import { queryClient } from '../lib/react-query';
import AppLoading from '../views/AppLoading';
import Login from '../views/Login';
import NotFound from '../views/NotFound';
import { appRoutes } from '@/configs/appRoutes';
import { useAuth0 } from '@/shared/auth0';
import MessageHub from '@/shared/features/message-hub/MessageHub';

const App = () => {
  const { loading: auth0Loading } = useAuth0();
  const appStateLoading = useAppState((state) => state.loading);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#38a169',
          },
        }}
      >
        <ThemeProvider>
          <DSThemeProvider>
            <GlobalStyle />
            <AppState>
              <MessageHub />
              {!auth0Loading && !appStateLoading ? (
                <Routes>
                  <Route path={appRoutes.LOGIN} element={<Login />} />
                  <Route path={appRoutes.PAGE_404} element={<NotFound />} />
                  <Route path="*" element={<MainRouter />} />
                </Routes>
              ) : (
                <AppLoading />
              )}
            </AppState>
          </DSThemeProvider>
        </ThemeProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default App;
